import { CDropdown } from './CDropdown.js';
import { CDropdownItem } from './CDropdownItem.js';
import { CDropdownHeader } from './CDropdownHeader.js';
import { CDropdownDivider } from './CDropdownDivider.js';
import { CDropdownMenu } from './CDropdownMenu.js';
import { CDropdownToggle } from './CDropdownToggle.js';

const CDropdownPlugin = {
    install: (app) => {
        app.component(CDropdown.name, CDropdown);
        app.component(CDropdownItem.name, CDropdownItem);
        app.component(CDropdownHeader.name, CDropdownHeader);
        app.component(CDropdownDivider.name, CDropdownDivider);
        app.component(CDropdownMenu.name, CDropdownMenu);
        app.component(CDropdownToggle.name, CDropdownToggle);
    },
};

export { CDropdown, CDropdownDivider, CDropdownHeader, CDropdownItem, CDropdownMenu, CDropdownPlugin, CDropdownToggle };
//# sourceMappingURL=index.js.map
